var map = {
	"./h5/kv2_eu.jpg": 563449,
	"./h5/kv2_uk.jpg": 576171,
	"./h5/kv_eu.jpg": 794815,
	"./h5/kv_uk.jpg": 984877,
	"./pc/kv2_eu.jpg": 508738,
	"./pc/kv2_uk.jpg": 176985,
	"./pc/kv_eu.jpg": 992293,
	"./pc/kv_uk.jpg": 25416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 448338;